import { AuthLayout } from "./auth-layout";

export function ClientSupportPage() {
  return (
    <AuthLayout>
      <div className="mx-auto w-full max-w-lg">
        <div>
          <h2 className="mt-8 text-4xl font-bold leading-9 tracking-tight text-gray-900">
            Oops! Something went wrong.
          </h2>
        </div>

        <div className="mt-6">
          <p className="mt-2 text-md leading-6 text-gray-500">
            Please contact{" "}
            <a
              href="mailto:support@pocketbook.tech"
              className="inline-flex items-center justify-center text-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50  text-slate-800 underline-offset-4 hover:underline "
            >
              support
            </a>{" "}
            and we'll get you back on track.
          </p>
        </div>
      </div>
    </AuthLayout>
  );
}
